export default __webpack_public_path__ + "static/media/640_business05-fr-web.df297b2c.png";